import { useEffect, useState } from "react";
import "aos/dist/aos.css";
import { Form, Input, Button, Alert, message } from "antd";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import { useDispatch, useSelector } from "react-redux";
import { RegisterAction } from "../../../redux/actions/AuthActions";
import { useRouter } from "next/router";
import HttpService from "../../../services/HttpService";

export default function SignUp({ reset = false }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password_confirmation, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [forgottenPasswordBtnLoading, setForgottenPasswordBtnLoading] =
  useState(false);

  const router = useRouter();
  const dispatch = useDispatch();
  const handleUserRegister = () => {
    if (reset) {
      const values = {
        email: email,
        password: password,
        password_confirmation: password_confirmation,
        code: router.query.code
      };
      const http = new HttpService();
      http
        .postData(values, "password/reset")
        .then((response) => {
          message.success(response.message);
          setForgottenPasswordBtnLoading(false);
          router.push('/signin');
        }).catch((response) => {
          message.error(response.message);
          setForgottenPasswordBtnLoading(false);
        });
    } else {
      const fields = {
        email: email,
        password: password,
        password_confirmation: password_confirmation,
      };
      dispatch(RegisterAction(fields, router));
    }
  };
  const selector = useSelector((state) => state.userAuth);

  useEffect(() => {
    if (selector?.authResponse?.message?.email?.[0] == "validation.unique") {
      setError(
        "Votre compte existe déjà. Vous pouvez vous connecter dès à présent."
      );
    } else if (
      selector?.authResponse?.message?.email?.[0] == "validation.exists"
    ) {
      setError(
        "Nous n'avons pas encore enregistré votre adresse email, veuillez contacter votre conseiller afin de régulariser votre situation."
      );
    }
  }, [selector]);

  return (
    <Form
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 13 }}
      onFinish={handleUserRegister}
    >
      <Form.Item
        label="E-mail"
        name="email"
        hasFeedback
        rules={[
          {
            type: "email",
            message: "Veuillez renseigner une adresse e-mail correcte.",
          },
          {
            required: true,
            message: "Veuillez renseigner votre email.",
          },
        ]}
      >
        <Input
          id={"email"}
          name="email"
          type="text"
          value={email}
          placeholder="Email"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
      </Form.Item>
      <Form.Item
        label="Mot de passe"
        name="password"
        hasFeedback
        rules={[
          {
            required: true,
            message: "Veuillez entrer votre mot de passe.",
          },
          {
            min: 8,
            message: "Veuillez entrer un mot de passe plus long.",
          },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*=+[{};:,.<>/?|])[A-Za-z\d~!@#$%^&*=+[{};:,.<>/?|]/,
            message:
              "Votre mot de passe doit contenir au minimum : une minuscule, une majuscule, un nombre et un caractère spécial.",
          },
        ]}
      >
        <Input
          id={"password"}
          name="password"
          type="password"
          value={password}
          placeholder="Mot de passe"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
      </Form.Item>
      <Form.Item
        label="Confirmer le mot de passe"
        name="password_confirmation"
        dependencies={["password"]}
        hasFeedback
        rules={[
          {
            required: true,
            message: "Veuillez confirmer votre mot de passe.",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }

              return Promise.reject(
                new Error("Les mots de passe ne correspondent pas.")
              );
            },
          }),
        ]}
      >
        <Input
          id={"password_confirmation"}
          name="password_confirmation"
          type="password"
          value={password_confirmation}
          placeholder="Confirmer le mot de passe"
          onChange={(e) => {
            setConfirmPassword(e.target.value);
          }}
        />
      </Form.Item>
      {error && <Alert description={error} type="error" />}
      <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
        <Button type="success" htmlType="submit" loading={forgottenPasswordBtnLoading}>
          {reset ? "Réinitialiser le mot de passe" : "M'enregistrer"}
        </Button>
      </Form.Item>
      {!reset && (
        <Form.Item
          wrapperCol={{ offset: 4, span: 16 }}
          className="noAccountWrapper"
        >
          Vous avez un compte ? <a href="/signin">Me connecter</a>
        </Form.Item>
      )}
    </Form>
  );
}
